{
  "sidenavMenuCloseTooltip": "메뉴 닫기",
  "sidenavMenuLockTooltip": "클릭하여 메뉴 잠금",
  "toggleSideNav": "측면 탐색 메뉴 전환"
}
